import axios from "axios";

// Configure axios defaults locally so this module can work standalone.
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
axios.defaults.baseURL = API_BASE_URL;

// Enable credentials (cookies) for all requests
axios.defaults.withCredentials = true;

// Add custom header to identify requests from admin panel
axios.defaults.headers.common["X-Admin-Panel"] = "true";

const STUDENTS_BASE = "/students";

export const studentAPI = {
  async getStudents({ page = 1, limit = 50, all = false } = {}) {
    const params = all ? { all: true } : { page, limit };
    return axios.get(STUDENTS_BASE, { params });
  },

  async createStudent(payload) {
    // payload: { name, email, phone, className, schoolName }
    return axios.post(STUDENTS_BASE, payload);
  },

  async createBulkStudents(payload) {
    // payload: { students: Array<student> }
    return axios.post(`${STUDENTS_BASE}/bulk`, payload);
  },

  async updateStudent(id, payload) {
    // payload: { name?, email?, phone?, className?, schoolName?, isActive? }
    return axios.patch(`${STUDENTS_BASE}/${id}`, payload);
  },

  async bulkUpdateStudents(payload) {
    return axios.post(`${STUDENTS_BASE}/bulk-update`, payload);
  },

  async deleteStudent(id) {
    return axios.delete(`${STUDENTS_BASE}/${id}`);
  },

  async extendTrial(id, payload) {
    // payload: { extendByDays: number } (default 7)
    return axios.post(`${STUDENTS_BASE}/${id}/extend-trial`, payload);
  },
};

export const licenseAPI = {
  async activateLicense(licenseKey, hardwareID) {
    return axios.post("/license/activate", { licenseKey, hardwareID });
  },

  async validateLicense(licenseKey, hardwareID) {
    return axios.post("/license/validate", { licenseKey, hardwareID });
  },

  async deactivateLicense(licenseKey, hardwareID) {
    return axios.post("/license/deactivate", { licenseKey, hardwareID });
  },

  async revokeLicense(licenseKey) {
    return axios.post("/license/revoke", { licenseKey });
  },

  async getLicenseInfo(licenseKey) {
    return axios.get(`/license/info/${licenseKey}`);
  },

  // New check license endpoints
  async checkLicense(licenseKey, options = {}) {
    const { useAuth = false, apiKey = null, useJWT = false } = options;

    let endpoint = "/license/check/public";
    const headers = {};

    if (useJWT) {
      endpoint = "/license/check/jwt";
    } else if (apiKey) {
      endpoint = "/license/check";
      headers["X-API-Key"] = apiKey;
    } else if (useAuth) {
      endpoint = "/license/check";
    }

    return axios.post(endpoint, { licenseKey }, { headers });
  },

  // Check license with API key (for external applications)
  async checkLicenseWithApiKey(licenseKey, apiKey) {
    return axios.post(
      "/license/check",
      { licenseKey },
      {
        headers: {
          "X-API-Key": apiKey,
        },
      }
    );
  },

  // Validate license with authentication
  async validateLicenseWithAuth(licenseKey, hardwareID, options = {}) {
    const { useJWT = false, apiKey = null } = options;

    let endpoint = "/license/validate";
    const headers = {};

    if (useJWT) {
      endpoint = "/license/validate/jwt";
    } else if (apiKey) {
      endpoint = "/license/validate/api";
      headers["X-API-Key"] = apiKey;
    }

    return axios.post(endpoint, { licenseKey, hardwareID }, { headers });
  },

  async listPool(params = {}) {
    return axios.get("/license/pool", { params });
  },

  async generatePool(payload) {
    return axios.post("/license/pool/generate", payload);
  },

  async redeemPool(payload) {
    return axios.post("/license/pool/redeem", payload);
  },
};

export default { studentAPI, licenseAPI };
